module.exports = __webpack_public_path__ + "img/p2.2a7e15e5.png";